export default __webpack_public_path__ + "static/media/Зайсан район ВКО.a4c43985.svg";